/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbFacilityPage } from './HchbFacilityPage';
import {
    HchbFacilityPageFromJSON,
    HchbFacilityPageFromJSONTyped,
    HchbFacilityPageToJSON,
} from './HchbFacilityPage';

/**
 * 
 * @export
 * @interface FindAllHchbFacilities200Response
 */
export interface FindAllHchbFacilities200Response {
    /**
     * 
     * @type {HchbFacilityPage}
     * @memberof FindAllHchbFacilities200Response
     */
    data?: HchbFacilityPage;
}

/**
 * Check if a given object implements the FindAllHchbFacilities200Response interface.
 */
export function instanceOfFindAllHchbFacilities200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbFacilities200ResponseFromJSON(json: any): FindAllHchbFacilities200Response {
    return FindAllHchbFacilities200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbFacilities200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbFacilities200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbFacilityPageFromJSON(json['data']),
    };
}

export function FindAllHchbFacilities200ResponseToJSON(value?: FindAllHchbFacilities200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbFacilityPageToJSON(value.data),
    };
}

